import InsufficientPermissionsPage from 'components/core/InsufficientPermissionsPage/InsufficientPermissionsPage';
import { isDefined } from 'shared/domain/role/isDefined';
import React from 'react';
import { useCurrentUserRole } from 'store/user';
import { Documentations } from 'views/documentations/table';
import { MemoGenericRoleAuthorizer } from '../GenericRoleAuthorizer';

export const AuthorizableDocumentations = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();

    const isCurrentUserAuthorized = isDefined(role);

    return (
      <MemoGenericRoleAuthorizer
        authorized={isCurrentUserAuthorized}
        unauthorized={!isCurrentUserAuthorized}
        authorizedComponent={Documentations}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);
